export default __webpack_public_path__ + "static/media/over-axlesGroup-weight.7ca0df99.svg";